import { ReactNode } from 'react';

import { Box, Stack, Text } from '@mantine/core';

import logo from '@assets/images/logo.png';

import { version } from '../../../../package.json';
import classes from './GuestLayout.module.css';

interface GuestLayoutProps {
  children: ReactNode;
}

export default function GuestLayout({ children }: GuestLayoutProps) {
  return (
    <div className={classes.wrapper}>
      <Stack align="center" p="xl" className={classes.form}>
        <img src={logo} alt="Logo Ieis" className={classes.logo} />
        <Box w="100%" mt="lg">
          {children}
        </Box>
        <div style={{ flexGrow: 1 }}></div>
        <Text size="xs" c="dimmed">
          v{version}
        </Text>
      </Stack>
    </div>
  );
}
